import React from "react";

import { useTranslation } from "utils";

import { CarbonProgram } from "models";

import { Button, Flex, Icon, Modal, Typography } from "components";

interface SubmitConfirmationModalProps {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  carbonProgram?: CarbonProgram;
}

const FootprintingSubmissionModal = ({ open, carbonProgram, onConfirm, onCancel }: SubmitConfirmationModalProps) => {
  const { t } = useTranslation("footprinting");

  return (
    <Modal
      showModal={open}
      title={t("modal.title")}
      footer={null}
      onCancel={onCancel}
      closable={true}
      wrapClassName="modalconfirm-modal"
      content={
        <>
          <Flex vertical className="footprinting-submission-modal">
            <Typography variant="paragraph-m" className="margin-top-100 margin-bottom-100 margin-right-100">
              {t("modal.subTitle")}
            </Typography>
            <Flex className="warning-container padding-100" gap="1rem">
              <Flex justify="flex-start" align="flex-start" className="margin-top-25">
                <Icon iconName="tabler/alert-triangle" />
              </Flex>

              <Flex vertical flex={1}>
                {carbonProgram?.platformFeatures.footprinting?.payouts === false ? null : (
                  <Flex>
                    <span className="margin-right-50">•</span>
                    <Typography variant="paragraph-m">
                      {t("modal.primaryText.start")}
                      <strong>{t("modal.primaryText.bold")}</strong>
                      {t("modal.primaryText.end")}
                    </Typography>
                  </Flex>
                )}
                <Flex className="margin-top-125">
                  <span className="margin-right-50">•</span>
                  <Typography variant="paragraph-m">
                    <strong>{t("modal.secondaryText.bold")}</strong> {t("modal.secondaryText.end")}
                  </Typography>
                </Flex>
              </Flex>
            </Flex>
            <hr className="margin-top-100 margin-bottom-100" />
            <Typography variant="paragraph-m" className="margin-bottom-200">
              {t("modal.confirm")}
            </Typography>
            <Flex justify="flex-end" gap={8}>
              <Button type="secondary" size="small" onClick={onCancel} className="button-no-min-width auto-width">
                {t("modal.cancel")}
              </Button>
              <Button type="primary" size="small" onClick={onConfirm} className="button-no-min-width auto-width">
                {t("modal.submitNow")}
              </Button>
            </Flex>
          </Flex>
        </>
      }
    />
  );
};

export default FootprintingSubmissionModal;
